import { StandardEnumOption } from "../../data/DataManager";
import { SchemaClient } from "../../common/GraphqlClient";
import { LinkedInstance } from "./external-sources/LinkedInstances";
import { Site } from "./external-sources/Sites";
import { Tag } from "./external-sources/Tags";
import { LabArea } from "./external-sources/LabAreas";
import { Reason } from "./external-sources/Reasons";


export * from "./external-sources/Entry";
export * from "./external-sources/LinkedInstances";
export * from "./external-sources/Sites";
export * from "./external-sources/Buildings";
export * from "./external-sources/Floors";
export * from "./external-sources/Rooms";
export * from "./external-sources/LabAreas";
export * from "./external-sources/Tags";
export * from "./external-sources/Reasons";
export * from "./external-sources/Groups";
export * from "./external-sources/Reviewers";
export * from "./external-sources/Users";
export * from "./external-sources/filterValues";
export * from "./external-sources/CategoryMappings";
export * from "./external-sources/GroupMasters";
export * from "./external-sources/ResponsiblePersons";


export type KeyValueConstruct<T = string | number> = {
  key: T;
  value: string;
};

/**
 * Shared context consumed by the field factories under `common/fields`. Both the
 * equipment and cluster schemas build a context assignable to this type; schema-
 * specific contexts (e.g. `EquipmentContext` with `sops`) extend it.
 */
export interface SchemaContext {
  client: SchemaClient;
  linkedInstances: LinkedInstance[];
  sites: Site[];
  tags: Tag[];
  labAreas: LabArea[];
  reasons: StandardEnumOption<Reason>[];
}

export const yesNoBooleanOptions: StandardEnumOption<boolean>[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];